import n from "./_baseEach.js";
var s = n;
function b(e, t, g, r) {
  return s(e, function(a, f, o) {
    t(r, a, g(a), o);
  }), r;
}
var c = b;
export {
  c as default
};
//# sourceMappingURL=_baseAggregator.js.map
